import type { BannerProps } from '@shopify/polaris';
import type { ReactNode } from 'react';

import { GBannerCard } from '~/presentation/ui';
import { INavigateKey } from '~/types/navigate';
import { Banner, Box } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

interface BannerTemplateWrapperProps {
  children: ReactNode;
  tone?: BannerProps['tone'];
  isBannerInCard?: boolean;
  hasUnpublishedAndDeleted?: boolean;
  screen?: INavigateKey;
}

export const BannerTemplateWrapper = ({
  children,
  screen,
  tone = 'warning',
  isBannerInCard = false,
  hasUnpublishedAndDeleted = false,
}: BannerTemplateWrapperProps) => {
  const [isDismissed, setIsDismissed] = useState(false);

  const { t } = useTranslation();

  const handleDismiss = () => {
    setIsDismissed(true);
  };

  if (isBannerInCard) {
    const padding = screen === INavigateKey.CampaignGroupAnalytic ? '0' : '400';

    return (
      <div role="presentation" className="cursor-default" onClick={(e) => e.stopPropagation()}>
        <Box paddingInline={padding} paddingBlockEnd={padding}>
          {screen === INavigateKey.Home || screen === INavigateKey.CampaignGroupAnalytic ? (
            <Banner tone={tone}>{children}</Banner>
          ) : (
            <GBannerCard tone={tone}>{children}</GBannerCard>
          )}
        </Box>
      </div>
    );
  }

  const title = hasUnpublishedAndDeleted
    ? t('This experiment has unpublished and deleted template')
    : t('This experiment has unpublished or deleted template');

  if (isDismissed) return null;

  return (
    <div role="presentation" className="cursor-default" onClick={(e) => e.stopPropagation()}>
      <Banner tone={tone} title={title} onDismiss={handleDismiss}>
        {children}
      </Banner>
    </div>
  );
};
